



























import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Overview"
})
export default class Overview extends Vue {}
